import { MdKeyboardArrowRight } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.li`
  display: flex;
  justify-content: flex-start;
  padding: 16px 8px;
  width: calc(100% - 32px);
  &:not(:last-child) {
    border-bottom: 1px solid ${ColorPalette.HEX.BrightGray};
  }
`;
export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Header: any = styled.div``;
Header.Title = styled.h5``;
Header.Text = styled.p`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const Switch = styled.div``;

export const ArrowIcon = styled(MdKeyboardArrowRight).attrs<any>((): any => ({}))`
  height: 20px;
  width: 20px;
  color: ${({ theme }) => theme.listPreviewCard.fontColor.empty};
  margin-left: auto;
`;

export const ToggleContainer = styled.div`
  position: relative;
`;
export const ToggleLoader = styled.div`
  position: absolute;
  background: ${ColorPalette.HEX.Lotion2};
  width: 100%;
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 4px;
  opacity: 0.8;
  z-index: 1;
  @media ${({ theme }) => theme.device.mobile} {
    background: rgba(${ColorPalette.RGB.White}, 0.7);
  }
`;
